'use client';
import React, { useEffect } from 'react';
import styled from '@benzinga/themetron';
import Checkbox from '../Checkbox';

export interface CheckboxGroupProps {
  className?: string;
  onChange: (value: string[]) => void;
  options: string[];
  selected?: string[];
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ className, onChange, options, selected = [] }) => {
  const [selectedValues, setSelectedValues] = React.useState<string[]>(selected);

  useEffect(() => {
    setSelectedValues(selected);
  }, [selected]);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      let result = [...selectedValues, value];
      const isSelected = selectedValues.includes(value);
      if (isSelected) {
        result = [...selectedValues].filter(selectedValue => selectedValue !== value);
      }
      setSelectedValues(result);
      onChange && onChange(result);
    },
    [onChange, selectedValues],
  );

  return (
    <Container className={`checkbox-group-container${className ? `${className}` : ''}`}>
      {options &&
        options.map(value => (
          <Checkbox
            checked={selectedValues.includes(value)}
            key={value}
            label={value}
            onChange={handleChange}
            value={value}
          />
        ))}
    </Container>
  );
};

export default CheckboxGroup;

const Container = styled.div`
  &.checkbox-group-container {
    display: flex;
    flex-direction: column;

    label {
      margin-right: 0.5rem;
      font-size: ${({ theme }) => theme.fontSize.base};
    }
    input {
      /* background-color: ${({ theme }) => theme.colorPalette.white};
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.borderRadius.default};
      font-size: ${({ theme }) => theme.fontSize.base};
      line-height: 1.5rem;
      padding: 0.25rem 0.5rem; */
    }
  }
`;
